import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingService } from '@r1-compass-library/services';

@Component({
    selector: 'r1-compass-lib-page-not-found',
    imports: [CommonModule],
    template: `
        <h1>404</h1>
        <b>Current route: {{ routingService.currentRoute$ | async }}</b>
    `,
    styles: ``,
})
export class PageNotFoundComponent {
    protected readonly routingService = inject(RoutingService);
}
